import React, { useCallback } from 'react'
import { makeStyles } from 'tss-react/mui'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import Banner from 'src/Components/banner/Banner'
import { BannerCloseTypes, BannerKey } from 'src/Libs/banners'
import { K1Information } from '@e3dc-react/icons'
import { Box, Button } from '@mui/material'
import { updateTourCompleted, updateTourRunning } from 'src/State/E-Mobility/EMobilityStateAction'
import { store } from 'src/State/Store'
import { queryClient } from '@e3dc-react/shell/Elements/Provider/QueryProvider'

export const setEMobilityTourRunning = (tourRunning: boolean): void => {
  queryClient.removeQueries({ queryKey: ['tariffs'], exact: false })
  queryClient.removeQueries({ queryKey: ['wallboxes'], exact: false })
  queryClient.removeQueries({ queryKey: ['chargingCards'], exact: false })
  queryClient.removeQueries({ queryKey: ['chargingSessions'], exact: false })
  queryClient.removeQueries({ queryKey: ['tariffDetails'], exact: false })
  queryClient.removeQueries({ queryKey: ['templates'], exact: false })

  store.dispatch(updateTourRunning(tourRunning))
  store.dispatch(updateTourCompleted(!tourRunning))
}

const useStyles = makeStyles()(theme => ({
  container: {
    backgroundColor: theme.palette.tourGuide.containerColor,
  },
}))

/**
 * Banner shown in the root of e-mobility section. It is shown in the rare cases when the network request sent to the
 * new e-mobility backend(HagerBridge) fails while fetching information if this installation was migrated to the new
 * backend and if we can show the new frontend.
 *
 * Once all installations are migrated and the old e-mobility code is deleted, this banner component can also be deleted.
 */
export const EMobilityTourBanner: React.FC = () => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()

  const handleStartTourButtonClick = useCallback(() => {
    setEMobilityTourRunning(true)
  }, [])

  return (
    <Box mb={2}>
      <Banner
        bannerKey={BannerKey.EmobilityTourBanner}
        i18nKey="emobility.tour.banner"
        button={
          <Button size="large" variant="contained" onClick={handleStartTourButtonClick}>
            {t('emobility.tour.take-a-quick-tour')}
          </Button>
        }
        closeType={BannerCloseTypes.permanentOrTemporary}
        icon={<K1Information color="inherit" fontSize="medium" />}
        containerStyle={classes.container}
      />
    </Box>
  )
}
